import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'sales-documents-divergent-data',
  storeModule.createStoreModule('sales-documents-divergent-data')
)
